export interface TablePreviewColumn {
  name: string;
  datatype: string;
  description: string;
}

export interface TablePreviewTableInfo {
  name: string;
  description: string;
  schemaname: string;
  columns: TablePreviewColumn[];
}

export interface TablePreviewMetadata {
  table: TablePreviewTableInfo;
  limit: number;
  offset: number;
  pageCount: number; // rows returned in this page (camelized from page_count)
  totalCount: number; // total rows in table (camelized from total_count)
  hasMore: boolean; // camelized from has_more
}

export interface TablePreviewResponse {
  metadata: TablePreviewMetadata;
  items: Record<string, unknown>[];
}

export const TablePreviewVariant = {
  COMPACT: "compact",
  FULL: "full",
} as const;
export type TablePreviewVariant = (typeof TablePreviewVariant)[keyof typeof TablePreviewVariant];

export interface TablePreviewModalProps {
  open: boolean;
  onClose: () => void;
  tableFqn: string;
  tableName: string;
  variant?: TablePreviewVariant;
}
